import { render, staticRenderFns } from "./LuckyRollWithPrizeEditor.vue?vue&type=template&id=13e781f4&"
import script from "./LuckyRollWithPrizeEditor.vue?vue&type=script&lang=js&"
export * from "./LuckyRollWithPrizeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports